import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import React from 'react';
import config from 'utils/config';
import formatData from 'utils/asset/formatAssetViewerData';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
import { useAuthContext } from 'hooks/useAuthContext';
import Box from 'components/Box';
import Comments from 'components/Comments';
import AssetViewerUI from 'screens/AssetViewerUI';
import InfoSection from 'screens/AssetViewerUI/InfoSection';
import ErrorAndLoadingWrapper from 'screens/AssetViewerUI/ErrorAndLoadingWrapper';
import RelatedPlaylists from 'screens/AssetViewerUI/RelatedPlaylists';
import AssetViewerContent from 'screens/AssetViewerUI/Content';
import { useAppNameContext } from 'hooks/useAppNameContext';

/**
 * The simple Asset viewer, used in playlist content manager and when opening a single asset in admin
 * !Achtung! This won't work without being wrapped in a {@link hooks/useAssetViewerContext#Provider|Asset Context Provider}
 * @returns {element} 	- The wrapped AssetViewer
 */
import { jsx as _jsx } from "react/jsx-runtime";
function AssetViewer(_ref) {
  var onClose = _ref.onClose;
  var _useAuthContext = useAuthContext(),
    setAuthUser = _useAuthContext.setAuthUser;
  var appNameContext = useAppNameContext();
  // SimpleAssetViewer should always use the admin-context event presentation.
  var isSimpleViewerContext = true;
  var _useAssetViewerContex = useAssetViewerContext(),
    asset = _useAssetViewerContex.asset,
    downloadUrl = _useAssetViewerContex.downloadUrl,
    error = _useAssetViewerContex.error,
    onError = _useAssetViewerContex.onError,
    isReady = _useAssetViewerContex.isReady,
    onLoad = _useAssetViewerContex.onLoad,
    markIframeContentAsLoaded = _useAssetViewerContex.markIframeContentAsLoaded;

  // TODO: consider using local guards against there being no asset
  if (!asset) return null;

  // Format data
  var _formatData = formatData({
      asset: asset,
      origin: appNameContext
    }),
    playlists = _formatData.playlists,
    tags = _formatData.tags;
  return /*#__PURE__*/_jsx(AssetViewerUI, {
    asset: asset,
    onClose: onClose,
    autoCompleteEnabled: false,
    isSimpleViewerContext: isSimpleViewerContext,
    renderContent: function renderContent() {
      return /*#__PURE__*/_jsx(ErrorAndLoadingWrapper, {
        isReady: isReady,
        error: error,
        children: /*#__PURE__*/_jsx(AssetViewerContent, {
          asset: asset,
          isSimpleViewerContext: isSimpleViewerContext,
          autoCompleteEnabled: false,
          downloadUrl: downloadUrl,
          markIframeContentAsLoaded: markIframeContentAsLoaded,
          onLoad: onLoad,
          onError: onError,
          setAuthUser: setAuthUser
        })
      });
    },
    renderInfoSection: function renderInfoSection() {
      return /*#__PURE__*/_jsx(InfoSection, {
        description: asset.description,
        tags: tags
      });
    },
    renderPlaylistInfo: function renderPlaylistInfo() {
      return !!(playlists !== null && playlists !== void 0 && playlists.length) && /*#__PURE__*/_jsx(RelatedPlaylists, {
        playlists: playlists
      });
    },
    renderComments: function renderComments() {
      return config.enableComments && /*#__PURE__*/_jsx(Box, {
        p: "m",
        children: /*#__PURE__*/_jsx(Comments, {
          contentId: Number(asset.id),
          totalCount: asset.commentCount
        })
      });
    }
  });
}
export default AssetViewer;